import styled from 'styled-components';
import { spaceMixin } from '@zillow/constellation';

export const StyledSpinnerContainer = styled.div<{ height?: string; padding?: string | number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ padding }) => spaceMixin(padding as any)};
  height: ${({ height }) => height};
`;
